import React from "react";
import { useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import "../Styles/User.css";

import axios from "axios";
import Cookies from "js-cookie";

import Card from "./Card";

export default function User(props) {
    let { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = React.useState({});
    const [recipes, setRecipes] = React.useState([]);
    const [favorites, setFavorites] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    
    function getTextColor(backgroundColor) {
        var r = parseInt(backgroundColor.substr(0,2),16);
        var g = parseInt(backgroundColor.substr(2,2),16);
        var b = parseInt(backgroundColor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? 'black' : 'white';
    }

    const disconnect = useCallback(() => {
        Cookies.remove("token", { path: "../"});
        props.updatenav[1](!props.updatenav[0]);
        navigate("/login");
    },[props.updatenav, navigate]);

    useEffect(() => {
    if (id === undefined || id === ":id") {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-user.php?token=" + Cookies.get("token"))
        .then((response) => {
            if (response.data.status === "success") {
                setUser(response.data.data.user);
                setFavorites(response.data.data.favorites);
                console.log(response.data.data);
                setRecipes(response.data.data.recipes);
                setLoading(false);
            } else if (response.data.data === "Invalid token") {
                disconnect();
            } else {
                alert(response.data.data);
            }
        })
        .catch((error) => {
            console.log(error);
        })
    }
    else {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-user.php?id=" + id)
        .then((response) => {
            if (response.data.status === "success") {
                setUser(response.data.data.user);
                setFavorites(response.data.data.favorites);
                setRecipes(response.data.data.recipes);

                setLoading(false);
            } else {
                if (response.data.data === "User not found") {
                    navigate("/404");
               }
            }
        })
        .catch((error) => {
            console.log(error);
        })
    }
    }, [id, disconnect, navigate]);
        
    if (loading) {
        return (
            <div className="User">
                <h1>Chargement...</h1>
            </div>
        );
    }
    /*
    Sample data object:
    {
        "user": {
            "username": "ano002",
            "profile_pic": "https://anatole-sot.xyz/api/recettes-gibli/uploads/users/gradient.jpg",
            "role": {
                "name": "Admin",
                "color": "FF0000"
            }
        },
        "favorites":[
            {
            "id": 19,
            "title": "Moelleux au chocolat",
            "time": 30,
            "people": 6
            }
        ],
        "recipes": [
            {
            "id": 19,
            "title": "Moelleux au chocolat",
            "time": 30,
            "people": 6
            }
        ]
    }
    */
    return (
        <div className="User">
            {id === ":id" || id === undefined ? <button className="disconnect" onClick={disconnect}>Déconnexion</button> : null}
            <div className="UserHeader">
                <img src={user.profile_pic} alt="Profile pic" />
                <div>
                    <h1>{user.username}</h1>
                    <p className="role" style={{backgroundColor: "#"+user.role.color, color: getTextColor(user.role.color)}}>{user.role.name}</p>
                    <p>Nombre de recettes : {recipes.length}</p>
                </div>
            </div>
            <div className="Favorites">
                <h2>Recettes Favorites ♥</h2>
                <div className="FavoriteRecipesList">
                    {favorites.length===0 ? "Aucune recettes favorites" : favorites.map((recipe,index) => {
                        return (
                            <Card className="UserRecipe" recette={recipe} key={index} />
                        );
                    })
                    }
                </div>
            </div>
            <div className="UserRecipes">
                <h2>Recettes Créées</h2>
                <div className="UserRecipesList">
                    {recipes.map((recipe,index) => {
                        return (
                            <Card className="UserRecipe" recette={recipe} key={index} />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

